module.exports = require('@/helper/hc-request/lib/hcRequest')
